<template>
  <editor :id="id" default-tab="settings" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Settings from './settings_editor/Settings'
export default {
  props: ['id'],
  components: {
    Editor
  },
  data() {
    return {
      tabs: [
        {title: "Settings", name: "settings", component: Settings}
      ]
    }
  }
}
</script>
